import React from 'react';
import type { Icon } from '@tabler/icons-react';
import styles from './toolbar.module.css';

interface ToolbarButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  variant?: 'primary' | 'secondary';
  icon?: Icon;
  /** Native hover text describing the action. */
  title?: string;
  disabled?: boolean;
}

/** Action button. Primary = accent blue; secondary = white/bordered with muted icon. */
export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  children,
  onClick,
  variant = 'secondary',
  icon: IconCmp,
  title,
  disabled = false,
}) => (
  <button
    type="button"
    className={`${styles.btn} ${variant === 'primary' ? styles.btnPrimary : styles.btnSecondary}`}
    onClick={onClick}
    title={title}
    disabled={disabled}
  >
    {IconCmp && (
      <span className={`${styles.btnIcon}${variant === 'secondary' ? ` ${styles.btnIconMuted}` : ''}`}>
        <IconCmp size={16} stroke={1.5} />
      </span>
    )}
    {children}
  </button>
);
